import { cloneDeep } from "lodash-es";
import Utils from "../../../../util";
import { ResultRow } from "../../../data-structures/results/result-row.model";
import { DIF } from "./dif.model";
import { DOF } from "./dof.model";
import { OAPP } from "./oapp.model";
import { OperatingUnits } from "./operating-units/operating-units.model";

interface TechnicalResultsGeneralInterface {
 'RESULTS.DATA.TECHNICAL.OAPP'?: OAPP;
 'RESULTS.DATA.TECHNICAL.OU'?: OperatingUnits;
 'RESULTS.DATA.TECHNICAL.DIF'?: DIF;
 'RESULTS.DATA.TECHNICAL.DOF'?: DOF;
 'RESULTS.DATA.TECHNICAL.UTILS'?: Record<string, ResultRow>;
}

export class TechnicalResultsGeneral {
  'RESULTS.DATA.TECHNICAL.OAPP';
  'RESULTS.DATA.TECHNICAL.OU';
  'RESULTS.DATA.TECHNICAL.DIF';
  'RESULTS.DATA.TECHNICAL.DOF';
  'RESULTS.DATA.TECHNICAL.UTILS';
  /** Operational and Performance Parameter */
  get oapp() {
    return this['RESULTS.DATA.TECHNICAL.OAPP'];
  }
  set oapp(value: OAPP) {
    this['RESULTS.DATA.TECHNICAL.OAPP'] = value;
  }
  /** Operational Units */
  get ou() {
    return this['RESULTS.DATA.TECHNICAL.OU'];
  }
  set ou(value: OperatingUnits) {
    this['RESULTS.DATA.TECHNICAL.OU'] = value;
  }
  /** Digester Input Flows */
  get dif() {
    return this['RESULTS.DATA.TECHNICAL.DIF'];
  }
  set dif(value: DIF) {
    this['RESULTS.DATA.TECHNICAL.DIF'] = value;
  }
  /** Digester Output Flows */
  get dof() {
    return this['RESULTS.DATA.TECHNICAL.DOF'];
  }
  set dof(value: DOF) {
    this['RESULTS.DATA.TECHNICAL.DOF'] = value;
  }
  get utils() {
    return this['RESULTS.DATA.TECHNICAL.UTILS'];
  }
  set utils(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.TECHNICAL.UTILS'] = value;
  }

  constructor(param: TechnicalResultsGeneralInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.OAPP'] = param['RESULTS.DATA.TECHNICAL.OAPP']
      ? new OAPP(param['RESULTS.DATA.TECHNICAL.OAPP'])
      : new OAPP();

    if (param['RESULTS.DATA.TECHNICAL.OU']) {
      this['RESULTS.DATA.TECHNICAL.OU'] = new OperatingUnits(param['RESULTS.DATA.TECHNICAL.OU']);
    } else {
      delete this["RESULTS.DATA.TECHNICAL.OU"];
    }

    this['RESULTS.DATA.TECHNICAL.DIF'] = param['RESULTS.DATA.TECHNICAL.DIF']
      ? new DIF(param['RESULTS.DATA.TECHNICAL.DIF'])
      : new DIF();

    this['RESULTS.DATA.TECHNICAL.DOF'] = param['RESULTS.DATA.TECHNICAL.DOF']
      ? new DOF(param['RESULTS.DATA.TECHNICAL.DOF'])
      : new DOF();

    this['RESULTS.DATA.TECHNICAL.UTILS'] = Utils.ObjectMapper(param['RESULTS.DATA.TECHNICAL.UTILS'] || {}, Utils.toResultRows);
  }

  deepCopy() {
    return new TechnicalResultsGeneral(cloneDeep(this));
  }
}
